import {enableProdMode} from '@angular/core';
import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';

import {AppModule} from './app/app.module';
import {environment} from './environments/environment';
import {GCS_OAUTH_TOKEN, SCOPES} from './app/constants/local-storage-constants';

const PENDING_GCS_RETURN_URL = 'pending_gcs_return_url';
const PENDING_GCS_SCOPES = 'pending_gcs_scopes';

// Handle the OAuth 2.0 implicit-grant redirect from Google before Angular boots.
// Under useHash:true routing, Angular would otherwise interpret #access_token=...
// as an unknown route and drop the OAuth response. Run synchronously here, store
// the token, then redirect back to the original page.
function handleGcsOauthRedirect(): void {
  if (!localStorage.getItem(PENDING_GCS_RETURN_URL)) {
    return;
  }
  const hash = window.location.hash;
  if (!hash || !hash.includes('access_token=')) {
    return;
  }
  const params = new URLSearchParams(hash.startsWith('#') ? hash.slice(1) : hash);
  const token = params.get('access_token');
  if (!token) {
    return;
  }
  localStorage.setItem(GCS_OAUTH_TOKEN, token);

  const pendingScopes = localStorage.getItem(PENDING_GCS_SCOPES);
  if (pendingScopes) {
    const existing = (localStorage.getItem(SCOPES) || '').split(' ').filter(s => s.length > 0);
    const merged = Array.from(new Set([...existing, ...pendingScopes.split(' ')])).join(' ');
    localStorage.setItem(SCOPES, merged);
  }

  const returnUrl = localStorage.getItem(PENDING_GCS_RETURN_URL);
  localStorage.removeItem(PENDING_GCS_RETURN_URL);
  localStorage.removeItem(PENDING_GCS_SCOPES);

  if (returnUrl) {
    window.location.replace(returnUrl);
  }
}

handleGcsOauthRedirect();

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
